import { useCartReferenceStore } from '@components/LoadCart'
import { CartFragmentFragment, useCartQuery } from '@generated'

export function useCart(): { cart: CartFragmentFragment | null; fetching: boolean } {
  const cartReferenceStore = useCartReferenceStore()
  let pause = true
  if (
    cartReferenceStore.reference !== null &&
    !cartReferenceStore.reference.includes('NOT-EXISTING')
  ) {
    pause = false
  }
  const [{ data, fetching }] = useCartQuery({
    variables: { reference: cartReferenceStore.reference },
    pause: pause,
  })

  return { cart: data?.cart || null, fetching }
}
